import React, { FunctionComponent, useState } from 'react'
import { useTranslation, Trans } from '../../../../../utils/convergence'
import { TradeInModal } from './TradeInModal'

import styles from './styles.module.css'

interface TradeInDisclaimerProps {
  show: boolean
}

export const TradeInDisclaimer: FunctionComponent<TradeInDisclaimerProps> = ({ show }) => {
  useTranslation(['summary'])
  const [showModal, setShowModal] = useState(false)

  if (!show) {
    return null
  }

  return (
    <div className={styles.tradeInDisclaimer}>
      <Trans
        i18nKey='summary:appleRetail.tradeInDisclaimer'
        components={{
          sup: <sup />,
          u: (
            <button
              type='button'
              className={styles.payTheDifferenceTrigger}
              onClick={() => {
                setShowModal(true)
              }}
              data-testid='pay-the-difference-trigger'
              aria-haspopup='dialog'
            />
          ),
        }}
      />
      <TradeInModal
        show={showModal}
        onClose={() => {
          setShowModal(false)
        }}
      />
    </div>
  )
}
